export interface PropsUseDisabledScroll {
  handlerDisabledScroll: (disabledScroll: boolean) => void;
}

let lockedScrollPosition: number | null = null;

export const useDisabledScroll: PropsUseDisabledScroll = {
  handlerDisabledScroll: (disabledScroll: boolean) => {
    if (disabledScroll && lockedScrollPosition === null) {
      lockedScrollPosition = window.scrollY;
      document.documentElement.classList.add("disabledScroll");
      document.body.classList.add("disabledScroll");
      document.body.style.position = "fixed";
      document.body.style.top = `-${lockedScrollPosition}px`;
      document.body.style.width = "100%";
      return;
    }

    if (!disabledScroll) {
      const scrollPosition = lockedScrollPosition;
      lockedScrollPosition = null;
      document.documentElement.classList.remove("disabledScroll");
      document.body.classList.remove("disabledScroll");
      document.body.style.removeProperty("position");
      document.body.style.removeProperty("top");
      document.body.style.removeProperty("width");

      if (scrollPosition !== null) {
        window.scrollTo(0, scrollPosition);
      }
    }
  },
};
